<!-- 旧机查询-旧机详情 -->
<template>
  <div class="app-container order-detail-wrap" v-loading="detailLoading">
    <div class="module-wrap">
      <el-descriptions title="工单信息" class="common-description-border">
        <el-descriptions-item label="工单编号">{{ detail.sourceWorkOrderNo || '--' }}</el-descriptions-item>
        <el-descriptions-item label="工单类型">{{ detail.serviceTypeName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="网点所属销司">{{ detail.regionName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="旧机条码所属销司">{{ detail.saleCompanyName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="回收订单编号">{{ detail.sendBackOrderId || '--' }}</el-descriptions-item>
        <el-descriptions-item label="旧机状态">{{ detail.statusName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="旧机结算">{{ detail.settlementStatusName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="渠道来源">{{ detail.salePlatformName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="网点编号">{{ detail.outletsNo || '--' }}</el-descriptions-item>
        <el-descriptions-item label="网点名称">{{ detail.outletsName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="承运商">{{ detail.transportCompany || '--' }}</el-descriptions-item>
        <el-descriptions-item label="归集仓">{{ detail.warehouseName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="回收人员">{{ detail.recycleName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="省">{{ detail.warehouseAddrProvName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="市">{{ detail.warehouseAddrCityName || '--' }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <el-descriptions title="旧机信息" class="common-description-border">
        <el-descriptions-item label="旧机品牌(工程师)">{{ detail.engineerOldMachineBrandName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="旧机品类(工程师)">{{ detail.engineerOldMachineTypeName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="旧机规格(工程师)">{{ formatEngineerSpec(detail.engineerOldMachineSpecModelName) }}</el-descriptions-item>
        <el-descriptions-item label="旧机品牌(网点)">{{ detail.oldMachineBrandName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="旧机品类(网点)">{{ detail.oldMachineTypeName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="旧机规格(网点)">{{ detail.oldMachineSpecModelName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="是否有铜管(网点)">{{ detail.existCopperPipeName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="是否有铜管(实收)">{{ detail.realCopperPipeName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="回收码">{{ detail.recycleCode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="整机编码">{{ detail.pillarsMachineEncode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="内机编码">{{ detail.internalMachineEncode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="内机条码">{{ detail.oldInternalBarcode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="再生资源入库(内)">{{ detail.internalWarehousingName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="外机编码">{{ detail.externalMachineEncode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="外机条码">{{ detail.oldExternalBarcode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="再生资源入库(外)">{{ detail.externalWarehousingName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="批次号">{{ detail.batchNumber || '--' }}</el-descriptions-item>
        <el-descriptions-item label="外机规格匹配">{{ detail.oldMachineSpecMatchName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="旧机图片" :span="3">
          <div class="img-list" v-if="oldMachinePhotoList.length">
            <el-image
              v-for="(item, index) in oldMachinePhotoList"
              :key="index"
              class="image-style"
              fit="cover"
              :src="item"
              :preview-src-list="oldMachinePhotoList"
            ></el-image>
          </div>
          <span v-else>--</span>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <el-descriptions title="时间信息" class="common-description-border">
        <el-descriptions-item label="工程师鉴定时间">{{ detail.appraisalTimeName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="回收完成时间">{{ detail.recoveryCompleteDateName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="再生资源入库时间">{{ detail.warehousingDateName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="结算时间">{{ detail.settlementDateName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ detail.lastModifiedDateName || '--' }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <div class="sub-title">旧机记录</div>
      <div class="table">
        <el-table :data="oldMachineRecordList">
          <el-table-column prop="feedbackType" label="操作类型" width="100"></el-table-column>
          <el-table-column prop="feedbackUserName" label="操作人" width="200"></el-table-column>
          <el-table-column prop="feedbackTime" label="操作时间" width="200">
            <template slot-scope="scope">
              {{ scope.row.feedbackTime | formatDateTimeDefault }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注说明" min-width="320"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="footer-wrap">
      <el-button size="medium" @click="goBack">返回</el-button>
    </div>
  </div>
</template>
<script>
import { getOldMachineRecycleDetail } from '@/api/oldForNew'

export default {
  name: 'searchOldDetailNew',
  data() {
    return {
      // 工单id，由旧机查询列表传入
      oldMachineId: this.$route.query.id,
      // 工单来源编号，由旧机查询列表传入
      sourceWorkOrderNo: this.$route.query.sourceWorkOrderNo || '',
      detail: {}, //旧机信息
      oldMachinePhotoList: [], //旧机照片
      oldMachineRecordList: [], //旧机记录（操作流水）
      detailLoading: false
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    //获取旧机详情（旧机信息、旧机照片、旧机记录）
    async getDetail() {
      if (!this.oldMachineId || !this.sourceWorkOrderNo) {
        this.$message.warning('参数异常，无法查看旧机详情')
        return
      }
      this.detailLoading = true
      let { statusCode, data } = await getOldMachineRecycleDetail({ id: this.oldMachineId, sourceWorkOrderNo: this.sourceWorkOrderNo })
      this.detailLoading = false
      if (statusCode != 200) {
        return
      }
      this.detail = (data && data.oldMachineDetail) || {}
      this.oldMachineRecordList = (data && data.operateRecordList) || []
      // 旧机照片为逗号分隔的文件名，需逐个换取图片地址
      this.getOldMachinePhotoList(data && data.oldMachinePhoto)
    },
    //获取旧机照片地址
    async getOldMachinePhotoList(photoStr) {
      const photoNames = photoStr ? photoStr.split(',').map(item => item.trim()).filter(Boolean) : []
      if (!photoNames.length) {
        return
      }
      const photoUrls = await Promise.all(photoNames.map(name => this.changeImg(name).catch(() => '')))
      this.oldMachinePhotoList = photoUrls.filter(Boolean)
    },
    //图片文件名换取图片地址
    changeImg(imgName) {
      return this.axios({
        url: process.env.BASE_API + `/autoapp-default-server-recovery/api/sms-annex/download-file?fileId=${imgName}`,
        method: 'GET',
        headers: { Authorization: this.$store.getters.token }
      }).then(res => res.request.responseURL)
    },
    //工程师鉴定的旧机规格，无数据时后端返回null、null
    formatEngineerSpec(value) {
      return value && value !== 'null、null' ? value : '--'
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.order-detail-wrap {
  .module-wrap {
    margin-bottom: 10px;
  }
  .sub-title {
    font-size: 16px;
    font-weight: bold;
    color: rgb(48, 49, 51);
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .img-list {
    display: flex;
    flex-wrap: wrap;
  }
  .image-style {
    width: 80px;
    height: 80px;
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .footer-wrap {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/searchOldDetailNew.vue